// removed by extract-text-webpack-plugin
module.exports = {"side-list":"app-components-SidebarReports-__style___1PI-y","box_center":"app-components-SidebarReports-__style___25K8O"};


//////////////////
// WEBPACK FOOTER
// ./app/components/SidebarReports/style.css
// module id = 2216
// module chunks = 0